import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import CompassIcon from "../../assets/CompassIconPlain.png";
import "./Login.css";

const forgotPasswordSchema = yup.object({
  email: yup
    .string("Enter your email.")
    .email("Enter a valid email.")
    .required("Email is required."),
});

require("dotenv").config();
const BASE_URL = (
  process.env.REACT_APP_BASE_URL || "http://localhost:5001/api/v1"
).replace("v1", "v2");

function ForgotPasswordPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values) => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      try {
        const response = await fetch(`${BASE_URL}/users/forgot-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: values.email,
          }),
        });

        const resp = await response.json();

        if (response.ok) {
          toast.success(resp.message);
          setTimeout(() => {
            navigate(`/users/reset-password`, {
              state: { email: values.email },
            });
          }, 1000);
        } else {
          toast.info(resp.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const navigate = useNavigate();

  return (
    <div className="App-content-center App-content-bg-custom">
      <div className="loginContainerUnique">
        <div className="loginLogoUnique">
          <img src={CompassIcon} alt="Compass Care by Gray Matters Alliance" />
          <h1 style={{ marginBottom: "24px", marginTop: "24px" }}>
            Enter your email
          </h1>
          <p style={{ fontSize: "1.2rem" }}>
            Well send you a verification code to reset your password.
          </p>
        </div>
        <div>
          <Box
            component="form"
            sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
            noValidate
            autoComplete="off"
            onSubmit={formik.handleSubmit}
          >
            <div>
              <TextField
                id="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                required
                style={{ width: "100%" }}
              />
              <br />
              <button
                type="submit"
                className="btn-primary loginButtonUnique"
                style={{ margin: "12px 0", width: "100%" }}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Submit"}
              </button>
            </div>
            <br />
            <a className="forgotLink" href="/login">
              Back to {process.env.REACT_APP_NAME}
            </a>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
